import { defineField, defineType } from "sanity";

export const appointmentType = defineType({
  type: "document",
  name: "appointmentType",
  title: "Appointment Content",
  fields: [
    defineField({
      name: "title",
      type: "string",
      title: "Title",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "type",
      type: "string",
      title: "Type",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "avatar",
      type: "image",
      title: "Avatar",
      options: {
        hotspot: true
      }
    }),
    defineField({
      name: "eventName",
      type: "string",
      title: "Event name"
    }),
    defineField({
      name: "joiningInstructions",
      type: "string",
      title: "Event joining instructions"
    }),
    defineField({
      name: "eventContent",
      type: "array",
      of: [
        {
          type: "object",
          title: "Appointment section content",
          fields: [
            defineField({
              name: "contentTitle",
              type: "string",
              title: "Title",
              validation: (Rule) => Rule.required()
            }),
            defineField({
              name: "content",
              type: "simpleBlocContent",
              title: "Content",
              validation: (Rule) => Rule.required()
            })
          ]
        }
      ]
    }),
    defineField({
      name: "language",
      type: "string",
      hidden: true,
      validation: (Rule) => Rule.required()
    })
  ]
});
